<template>
  <div :style="fileList.length > 0 ? 'margin-bottom: -50px;' : ''">
    <input
      ref="file"
      type="file"
      @change="handleFileChange"
      style="display: none;"
      :accept="accept"
      multiple
    />

    <div class="hf fl aic" v-if="fileList.length === 0">
      <p class="empty-state hf mr-3">U heeft nog geen bestanden toegevoegd.</p>
      <Button @click="$refs.file.click()" style="min-width: 180px;" secondary>Bestanden Kiezen</Button>
    </div>

    <div v-if="fileList.length > 0">
      <div v-for="(file, i) in fileList" :key="'file-'+i" class="hf fl aic mb-3">
        <header-element class="mr-3">{{file.name}}</header-element>
        <header-element-button remove @click="() => removeFile(file)">
          <v-icon>delete</v-icon>
        </header-element-button>
      </div>
      <Button
        @click="$refs.file.click()"
        style="min-width: 180px; float:right;"
        secondary
      >Bestanden Toevoegen</Button>
      <div style="clear: both" />
    </div>

    <div v-if="shouldShowErrors">
      <p
        v-for="(error, index) in this.errors"
        :key="index"
        :style="getErrorsStyle()"
        class="validation-warning"
      >{{error}}</p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Button from '../buttons/Button.vue';
import Vue from 'vue';

import HeaderElement from '../elements/HeaderElement.vue';
import HeaderElementButton from '../elements/HeaderElementButton.vue';

export default {
  name: 'MultipleFileUpload',
  components: {
    Button,
    HeaderElement,
    HeaderElementButton
  },
  props: {
    placeholder: String,

    right: Boolean,
    left: Boolean,
    center: Boolean,

    accept: String,
    maxFileSize: Number | undefined,
    errors: null
  },
  data () {
    return {
      shouldShowErrors: true,
      fileList: []
    };
  },
  computed: {

  },
  methods: {
    addFiles (files) {
      
      const allowedFiles = this.filterAllowedDocuments( [...files])
      this.fileList = _.union(this.fileList, allowedFiles);
      this.$emit('input', this.fileList);
    },
    removeFile (file) {
      let index = this.fileList.findIndex(f => f.name === file.name);
      this.fileList.splice(index, 1);
      this.$emit('input', this.fileList);
    },
    handleFileChange (e) {
      this.addFiles(e.target.files);
    },
    hasValidExtension (fileName) {
      const fileExtension = fileName.split('.')[fileName.split('.').length - 1];
      const hasValidExtension = this.accept.includes(fileExtension);
      if (!hasValidExtension) {
        Vue.toasted.error(Vue.prototype.$t('fileUpload.invalid-file-type'), {
          icon: 'error'
        });
      }
      return hasValidExtension;
    },
    filterAllowedDocuments (files) {
      return files.filter((file) => this.isFileSizeValid(file.size) && this.hasValidExtension(file.name));
    },
    isFileSizeValid (fileSize) {
      if (!this.maxFileSize) return true;

      const hasValidFileSize = fileSize <= this.maxFileSize;
      
      if (!hasValidFileSize) {
        Vue.toasted.error(Vue.prototype.$t('fileUpload.invalid-file-size'), {
          icon: 'error'
        });
      }

      return hasValidFileSize;
    },


    getErrorsStyle () {
      if (this.right) {
        return 'text-align: right;';
      } else if (this.left) {
        return 'text-align: left;';
      } else if (this.center) {
        return 'text-align: center;';
      } else {
        return 'text-align: left;';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";
/* Don't forget to hide the original file input! */

.multiple-file-upload {
  border-radius: $border-radius;
  background-color: $gray-lighten-3;
  padding: 20px;
}

.empty-state {
  padding: 11px 15px;
  border: 1px solid $gray-lighten-1;
  border-radius: $border-radius;
}

.validation-warning {
  color: $error;
  padding-top: 7px;
  font-size: 0.9em;
}
</style>
